import FilterHeading from "../../../Invoicing/FilterHeading";
import React from "react";
import FilterBlankHeading from "../../../Invoicing/FilterBlankHeading";

function ActiveHeadings({data, activeTab, vehicleStatus, filters, setPage, setFilters}) {
  const headings = [
      {
          label:"Registration",
          field: "registration",
          labelField: "registration",
          display: true
      },
      {
          label:"Fleet Number",
          display: activeTab === "fleet",
          field: "fleet_number",
          labelField: "fleet_number",
          plusBlanks: true,
          objField: false
      },
      {
        label: "Owner",
        field: "owner",
        labelField: "owner__display_name",
        display: true
      },
      {
          label:"Make",
          field:"make",
          labelField:"make__name",
          display: true
      },
      {
          label:"Model",
          field:"model",
          labelField:"model__name",
          display: true
      },
      {
          label: "Variant",
          display: true
      },
      {
          label: "Department Owner",
          field: "department",
          labelField: "department__name",
          display: true
      },
      {
          label: "Hire Customer",
          field: "hire_customer",
          labelField: "hire_customer__display_name",
          display: true
      },
      {
          label: "Key Number",
          field: "key",
          labelField: "key__key_number",
          display:true
      },
      {
          label:"Chassis No.",
          display:true
      },
      {
          label: "Tracker IMEI",
          display: true
      },
      {
          label:"Type",
          field:"type",
          labelField:"type__name",
          display:true
      },
      {
          label: "Customer Vehicle Owner",
          field: "owner",
          labelField: "owner__display_name",
          display: true
      },
      {
          label: "Finance Company",
          field: "finance_agreements__finance_company",
          labelField: "finance_agreements__finance_company",
          display: true
      },
      {
          label:"Remaining Capital",
          display:true
      },
      {
          label:"Depreciated Value",
          display:true
      },
      {
          label:"Purchase Date",
          display:true
      },
      {
          label: "Quote Status",
          display: true
      }
  ];
  return (
      <tr>
          {headings.map(heading => {
              if(heading.display) {
                  if (!heading.field) {
                        return <th key={heading.label}>{heading.label}</th>;
                  }
                  if (heading.blank) {
                      return (
                          <FilterBlankHeading
                              key={heading.label}
                              heading={heading}
                              setFilters={f => {
                                  setPage(1);
                                  setFilters(f);
                              }}
                              filters={filters}
                          />
                      );
                  }
                  return (
                      <FilterHeading
                          key={heading.label}
                          heading={heading}
                          setFilters={f => {
                              setPage(1);
                              setFilters(f);
                          }}
                          filters={filters}
                          options={data.filter_list[heading.field]}
                      />
                  );
              }
          })}
      </tr>
  )
}

export default ActiveHeadings;
